// extracted by mini-css-extract-plugin
module.exports = {"root":"AddNewScopeModal_root__rpQg1"};